import { BookingType } from "../../../features/Booking-Form/typings/booking-inputs";

export type CanBookInactiveResourcesAsAdminParams = {
  isCompanyAdmin: boolean;
  isLocationAdmin: boolean;
  bookingType: BookingType | null | undefined;
  locationInventoryId: number | null | undefined;
  locationAdminLocationIds: readonly number[];
};

/**
 * Company and location admins may book inactive workplace/conference resources in scope.
 * Fleet (vehicle) bookings are never allowed via this bypass.
 */
export function canBookInactiveResourcesAsAdmin({
  isCompanyAdmin,
  isLocationAdmin,
  bookingType,
  locationInventoryId,
  locationAdminLocationIds
}: CanBookInactiveResourcesAsAdminParams): boolean {
  if (bookingType === BookingType.VEHICLE) {
    return false;
  }

  if (locationInventoryId == null) {
    return false;
  }
  if (isCompanyAdmin) {
    return true;
  }

  if (isLocationAdmin) {
    return locationAdminLocationIds.includes(locationInventoryId);
  }

  return false;
}
